import {
  DatePicker,
  Input,
  Modal,
  Popconfirm,
  Select,
  Table,
  TableProps,
  Tag,
} from "antd";
import { IoMdSearch } from "react-icons/io";
import "./transaction-report.scss";
import Button from "src/libraries/components/button/Button";
import { TransactionReportApdapter } from "./transaction-report-adapter";
import { ENUM_STATUS_NUMBER } from "src/libraries/enums/constant";
import LoadingSpinnerScreen from "src/libraries/components/loading-spinner/loading-spinner.screen";
import { Empty } from "antd";
import { MultiTransactionReportData } from "src/libraries/types/report-transaction";
import moment from "moment";
import DetailTransactionModal from "./detail-modal/detail-transaction-modal";
import convertToCurrency from "src/libraries/utils/convert-to-currency";
export const TransactionScreen = () => {
  const { RangePicker } = DatePicker;
  const {
    loading,
    isModalVisible,
    selectedTransaction,
    showModal,
    handleOk,
    handleCancel,
    transactionList,
    handleFilterChange,
    handleSearch,
    filters,
    currentPage,
    pageSize,
    total,
    setPageSize,
    setCurrentPage,
  } = TransactionReportApdapter();

  const columns: TableProps<MultiTransactionReportData>["columns"] = [
    {
      title: "Mã giao dịch",
      dataIndex: "referenceLabelCode",
      key: "referenceLabelCode",
    },
    {
      title: "Thời gian giao dịch",
      dataIndex: "payDate",
      key: "payDate",
      render: (text) =>
        moment(text, "YYYYMMDDHHmmss").format("DD-MM-YYYY HH:mm:ss"),
    },
    {
      title: "Số tiền",
      dataIndex: "amount",
      key: "amount",
      render: (text: any) => (
        <div style={{ color: "cornflowerblue", fontWeight: 700 }}>
          {convertToCurrency(text)}đ
        </div>
      ),
    },
    {
      title: "Mã ngân hàng",
      dataIndex: "bankId",
      key: "bankId",
    },
    {
      title: "Tên tài khoản",
      dataIndex: "bankAccountName",
      key: "bankAccountName",
      render: (text: any) => (text === null ? "Không có" : text),
    },
    {
      title: "Số tài khoản",
      dataIndex: "bankAccountNumber",
      key: "bankAccountNumber",
      render: (text: any) => (text === null ? "Không có" : text),
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        switch (text) {
          case "2":
            return <Tag color="green">Thành công</Tag>;
          case "1":
            return <Tag color="orange">Khởi tạo</Tag>;
          case "4":
            return <Tag color="red">Hoàn tiền</Tag>;
          case "5":
            return <Tag color="geekblue">Hoàn tiền thành công</Tag>;
          default:
            return <Tag color="gray">Chưa có trạng thái này</Tag>;
        }
      },
    },
    {
      title: "Tên kênh",
      dataIndex: "paymentChannelName",
      key: "paymentChannelName",
      render: (text: any) => (text === null ? "Không có" : text),
    },
    // {
    //   title: "Trạng thái hoàn tiền",
    //   dataIndex: "refundStatus",
    //   key: "refundStatus",
    //   render: (text: any) =>
    //     text === "200" ? <Tag color="green">Thành công</Tag> : `Không có`,
    // },
    // {
    //   title: "Lượng tiền hoàn",
    //   dataIndex: "refundAmount",
    //   key: "refundAmount",
    //   render: (text: any) => (text === null ? "Không có" : `${text} đ`),
    // },
  ];
  return (
    <div style={{ height: "100vh", overflowY: "auto" }}>
      <div className="transaction-report-screen">
        <div className="filter-bar">
          <Select
            className="filter-select"
            placeholder="Trạng thái"
            onChange={(value) => handleFilterChange("status", value)}
            value={filters.status}
          >
            <Select.Option value={"ALL"}>Tất cả</Select.Option>
            <Select.Option value={ENUM_STATUS_NUMBER.INITIAL}>
              Khởi tạo
            </Select.Option>
            <Select.Option value={ENUM_STATUS_NUMBER.SUCCESS}>
              Thành công
            </Select.Option>
            <Select.Option value={ENUM_STATUS_NUMBER.REFUND}>
              Hoàn tiền
            </Select.Option>
          </Select>
          <Input
            className="filter-input"
            placeholder="Mã giao dịch"
            value={filters.inputText}
            onChange={(e) => handleFilterChange("billNumber", e.target.value)}
          />
          <RangePicker
            className="filter-range-picker"
            format="YYYY-MM-DD HH:mm"
            showTime
            showSecond={false}
            onChange={(dates) =>
              handleFilterChange("dateRange", dates ? dates.map((d) => d) : [])
            }
          />
          <Button
            className="filter-button"
            background="#022e45"
            textColor="#FFF"
            borderColor="#022e45"
            onClick={() => handleSearch("filter")}
          >
            <div className="button-content">
              <i>
                <IoMdSearch color="#fff" size={24} />
              </i>
              <p className="button-text">{"Tìm kiếm"}</p>
            </div>
          </Button>
        </div>
      </div>
      {loading ? (
        <LoadingSpinnerScreen className="big" />
      ) : (
        <Table
          style={{ width: "98%" }}
          rowKey="id"
          className="transfer-table"
          columns={columns}
          dataSource={transactionList}
          onRow={(record) => ({
            onClick: () => showModal(record),
          })}
          locale={{ emptyText: <Empty description="No Data" /> }}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: total,
            onChange: (page, size) => {
              setCurrentPage(page);
              setPageSize(size);
            },
          }}
        />
      )}

      <Modal
        title="Chi tiết giao dịch"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose={true}
      >
        {selectedTransaction && (
          <DetailTransactionModal
            handleSearch={handleSearch}
            selectedTransaction={selectedTransaction}
            handleCancel={handleCancel}
          />
        )}
      </Modal>
    </div>
  );
};
